import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import Select from '@/app/modules/shared/components/forms/inputs/select/select.vue';
import TimeRange from '@/app/modules/shared/components/forms/inputs/time-range/time-range.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { SlotDayTimeResponsible } from '@shared/interfaces/slot-day-time-responsible';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
import moment from 'moment';
@Component({
  name: 'bpc-time-slot',
  components: {
    ValidationProvider,
    ValidationObserver,
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
    'bpc-entity-select': EntitySelect,
  },
})
export default class DayTimeResponsibleRepeater extends mixins(AbstractField) {
  $refs: {
    daySelet: InstanceType<typeof Select>;
    timeRange: InstanceType<typeof TimeRange>;
  };

  // PROPS

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly value: SlotDayTimeResponsible[];

  @Prop({ type: Boolean, default: false }) readonly disableFields: boolean;

  // DATA
  // It works as "formModel"
  public slots: SlotDayTimeResponsible[] = [];
  public errors: string[] = [];
  selectedContacts = [];

  public day: string = '';
  public time_range = { start_time: '', end_time: '', duration: 0 };

  public dayOptions: object[] = [
    { text: '', value: '' },
    { text: 'bookings.schedule_slot_ranges.mon.label', value: 'mon' },
    { text: 'bookings.schedule_slot_ranges.tue.label', value: 'tue' },
    { text: 'bookings.schedule_slot_ranges.wed.label', value: 'wed' },
    { text: 'bookings.schedule_slot_ranges.thu.label', value: 'thu' },
    { text: 'bookings.schedule_slot_ranges.fri.label', value: 'fri' },
    { text: 'bookings.schedule_slot_ranges.sat.label', value: 'sat' },
    { text: 'bookings.schedule_slot_ranges.sun.label', value: 'sun' },
  ];

  // COMPUTED
  get hours(): number[] {
    const start_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_start_hour?.slice(0, 2) || '7';
    const end_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_end_hour?.slice(0, 2) || '22';
    return Array.from({ length: parseInt(end_hour) - parseInt(start_hour) + 1 }).map(
      (_, i) => i + parseInt(start_hour),
    );
  }

  // LIFECYCLE
  mounted() {
    if (this.value && this.value.length) {
      this.slots = [];
      this.value.forEach(slot => {
        this.slots.push({
          day: slot.day,
          time_range: {
            start_time: slot.time_range.start_time,
            end_time: slot.time_range.end_time,
            duration: this.calcDuration(slot),
          },
          responsible_ids: slot.responsible_ids,
        });
        this.errors.push(null);
      });
    } else {
      this.addSlot();
    }
  }

  // METHODS
  addSlot() {
    this.slots.push({
      day: '',
      time_range: {
        start_time: '',
        end_time: '',
        duration: 0,
      },
      responsible_ids: [],
    });
    this.errors.push(null);
  }

  removeSlot(index) {
    this.slots.splice(index, 1);
    this.errors.splice(index, 1);
  }

  slotByDay(day) {
    return this.slots.filter(slot => slot.day === day);
  }

  calcDuration(slot): number {
    if (slot.time_range.start_time && slot.time_range.end_time) {
      const startDate = moment('2000-01-10 ' + slot.time_range.start_time, 'YYYY-MM-DD hh:mm');
      const endDate = moment('2000-01-10 ' + slot.time_range.end_time, 'YYYY-MM-DD hh:mm');
      return endDate.diff(startDate, 'minutes');
    }
    return 0;
  }

  changeStartTime(slot) {
    if (slot.time_range.start_time && !slot.time_range.end_time) {
      slot.time_range.duration = 60;
      slot.time_range.end_time = moment(slot.time_range.start_time, 'HH:mm:ss')
        .add(slot.time_range.duration, 'minutes')
        .format('HH:mm');
    } else if (slot.time_range.start_time && slot.time_range.end_time) {
      slot.time_range.end_time = moment(slot.time_range.start_time, 'HH:mm:ss')
        .add(slot.time_range.duration, 'minutes')
        .format('HH:mm');
      slot.time_range.duration = this.calcDuration(slot);
    }
    this.checkState();
  }

  changeEndTime(slot) {
    if (slot.time_range.start_time && slot.time_range.end_time) {
      slot.time_range.duration = this.calcDuration(slot);
    } else {
      slot.time_range.duration = 0;
    }
    this.checkState();
  }

  // FIXME For the moment, this checkState only show a message but do not block the call to backend.
  // It would be interesting to make the fieldwrapper validation work in front and pass it
  // the state, the error and the showError parameters to block the call to backend if there
  // is an error in the field
  checkState() {
    this.slots.forEach((slot, i) => {
      if (slot.time_range.duration < 0) {
        this.errors[i] = this.$t(
          'activities.activity_session.negative_duration_not_allowed',
        ) as string;
      } else {
        this.errors[i] = null;
      }
    });
  }

  // WATCHERS
  @Watch('slots')
  onValueChange() {
    this.$emit('input', this.slots);
  }
}
